import React, { useState, useEffect, useContext } from "react";
import { Grid, Typography, Box, Button} from "@mui/material";
import { Select, MenuItem, FormControl, FormHelperText } from "@mui/material";
import "./ExitManagement.css";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as moment from "moment";
import exitManagementAPI from "apis/panel/ExitManagement/exitManagement";
import swal from 'sweetalert';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from "@mui/icons-material/Close";



import {

  TextField,
  

} from "@mui/material";
import { Dialog, DialogActions, DialogContent,IconButton, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "../../../../node_modules/@mui/material/index";

const ExitManagementManager = () => {

  const [resignations, setResignations] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0);
  const [HRlist, setHRlist] = useState(true);
  const [resignationDetails, setResignationDetails] = useState("");
  const [approval, setApproval] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [approvalReason, setApprovalReason] = useState("");
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const limit = 10;
  const [offset, setOffset] = useState(1);

   const [selectedYear, setSelectedYear] = useState(new Date());
    const handleYearChange = (newYear) => {
    setSelectedYear(newYear);
    setOffset(1)
    setSearchValue("")
  };

console.log(searchValue,'daskldjklasjdklasj');

 

  const [openModal, setOpenModal] = useState(false);
  const [exitDetailsView,setExitDetailsView] = useState([])
  const [approvalDetails,setApprovalDetails] = useState([])
  const [approverLevel,setApproverLevel] = useState('')

   const {getManagerAllResignationsAPI,managerUpdateResignationAPI,getOneResignationsAPI,getResignationApprovalDetailsAPI} = exitManagementAPI()

  const handleOpenSubmitModal = async () => {
    let errors = {};

    if (!approval) {
      errors.approval = "Approval Status is required";
    }
    if (approval === "Rejected" && !rejectionReason.trim()) {
      errors.rejectionReason = "Reason for rejection is required";
    }

     if (approval === "Approved" && !approvalReason.trim()) {
      errors.approvalReason = "Reason for approval is required";
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      toast.error("Please fill in the required fields.");
      return;
    }
      const confirmation = await swal({
            title: "Confirm",
            text: " Are you sure you want to proceed with the Approve / Rejection?",
            icon: "warning",
            buttons: {
              cancel: {
                text: "Reject",
                value: false,
                visible: true,
                className: "swal-button-disagree",
              },
              confirm: {
                text: "Accept",
                value: true,
                visible: true,
                className: "swal-button-agree",
              },
            },
            dangerMode: false,
          });
if(confirmation){
  handleApproveResignation(resignationDetails.exitId)
}
  };
  

  useEffect(() => {
    fetchAllResignations();
  }, [offset, selectedYear, searchValue]);

  
  const fetchAllResignations = async () => {
    try {

      const query = {
          offset: (offset - 1) * limit,
          limit: limit,
        year: selectedYear,
        }
         if (searchValue) {
        query = {
          ...query,
          searchValue,
        };
      }
      
      dispatch({ type: "SET_LOADING", payload: true });
      
      const data = await getManagerAllResignationsAPI(query);

      // Check the response format and process the resignations
      if (data.status === "Ok" && Array.isArray(data.allResignations)) {
        // Update the state with the resignations directly
        setResignations(data.allResignations);
        setCount(data.count);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignations:", error);
    } finally {
      // Clear the loading state after processing
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const tableDataModal = resignations.map((resignation, index) => [
    index + 1 + (offset - 1) * limit,
    resignation.employeeCode, 
    resignation.firstName, 
    resignation.role, 
    resignation.dept,
    resignation.requestStatus,
    resignation?.attritionType ? resignation?.attritionType : 'Null',
    resignation?.approverLevel,
    resignation.approvalStatus? resignation.approvalStatus === 'Manager Approved'?'L1 Manager Approved' :resignation.approvalStatus:'' ,
    new Date(resignation.appliedOn).toISOString().split("T")[0],
    <Tooltip
     title="Click to view approval screen"
      key={resignation.exitId}
    >
      <span className="jobType">
  <RemoveRedEyeIcon
    style={{
      color:
        (
          (resignation?.approverLevel === "Manager (level 1)" &&
            (resignation.approvalStatus === "Resignation Submitted" ||
             resignation.approvalStatus === "Withdrawal Submitted")) ||
          (resignation?.approverLevel === "Manager (level 2)" &&
            resignation.approvalStatus === "Manager Approved")
        )
          ? "#E97000"
          : "grey",
      cursor:
        (
          (resignation?.approverLevel === "Manager (level 1)" &&
            (resignation.approvalStatus === "Resignation Submitted" ||
             resignation.approvalStatus === "Withdrawal Submitted")) ||
          (resignation?.approverLevel === "Manager (level 2)" &&
            resignation.approvalStatus === "Manager Approved")
        )
          ? "pointer"
          : "not-allowed",
    }}
    
    onClick={() => {
     
      if (
        (resignation?.approverLevel === "Manager (level 1)" &&
          (resignation.approvalStatus === "Resignation Submitted" ||
           resignation.approvalStatus === "Withdrawal Submitted")) ||
        (resignation?.approverLevel === "Manager (level 2)" &&
          resignation.approvalStatus === "Manager Approved")
      ) {
        setApproverLevel('')
        fetchOneResignation(resignation.exitId);
        setApproverLevel(resignation?.approverLevel)
      } else {
        toast.info(
          "This resignation has been approved or rejected and cannot be edited."
        );
      }
    }}
  />
</span>
    </Tooltip>,

    <Tooltip
      title={
        
           "Click to view Approval Details"
      }
      key={resignation.exitId}
    >
      <span className="jobType">
        <InfoIcon
          style={{
            color: (resignation.approvalStatus )
              ? "#E97000"  
              : "grey",  
            cursor: (resignation.approvalStatus)
              ? "pointer"   
              : "not-allowed",  
          }}
          onClick={() => {
            if (resignation.approvalStatus ) {
              handleOpenDetails(resignation)
            } 
          }}
        />
      </span>
   </Tooltip>
  ]);


  const handleApproveResignation = async (exitId) => {
    try {
     
      dispatch({ type: "SET_LOADING", payload: true });

      const body = {
        exitId,
        status: approval,
        approverLevel:approverLevel,
       ...(approval === "Rejected" && { rejectReason: rejectionReason }),
        ...(approval === "Approved" && { approvalReason: approvalReason })
      };

        const data = await managerUpdateResignationAPI(body);
        if (data.status === "Ok" && data.affected === 1) {
        
          if (approval === "Approved") {
            toast.success("Resignation approved successfully");
          } else if (approval === "Rejected") {
            toast.error("Resignation rejected successfully");
          } else {
            toast.info("Resignation status updated");
          }
          fetchAllResignations();
          setHRlist(true);
          setIsSubmitModalOpen(false);
          setApproverLevel('')
          handleClose()
        } else {
          toast.error("Error: " + (data.message || "Approval failed"));
          setIsSubmitModalOpen(false);
           setApproverLevel('')
           handleClose()
        }
      
    } catch (error) {
      toast.error("Error approving resignation: " + error.message);
     
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
      setIsSubmitModalOpen(false);
    }
  };


  const fetchOneResignation = async (exitId) => {
    try {
    
      dispatch({ type: "SET_LOADING", payload: true });

      const data = await getOneResignationsAPI(exitId);

      if (data.status === "Ok" && Array.isArray(data.oneResignation)) {
       
        const resignationDetails = data.oneResignation[0];

       
        setResignationDetails(resignationDetails);
        setHRlist(false);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignation details:", error);
    } finally {
     
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleOpenDetails= async (exitDetails)=>{
     try {
    
      dispatch({ type: "SET_LOADING", payload: true });

       const data = await getResignationApprovalDetailsAPI(exitDetails?.exitId);

      if (data.status === "Ok" && Array.isArray(data.oneResignation)) {
       
        const resignationDetails = data.oneResignation;

       setApprovalDetails(resignationDetails)
         setExitDetailsView(exitDetails)
        setOpenModal(true)
       
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignation details:", error);
    } finally {
     
      dispatch({ type: "SET_LOADING", payload: false });
    }
   
   

  }

  const handleClose = () => {
  setOpenModal(false);
  setExitDetailsView(null);
  setApprovalDetails(null)
  setApproval("")
  setRejectionReason("")
  setApprovalReason("")
  setErrorMessages({})
  
};


  return (


    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>


        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick 
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '100%', overflowX: 'auto', margin: "2%" }}>
            {/* <Typography
              variant="h5"
              align="center"
              className="self-title"

            >
              Resignation Dashboard
            </Typography> */}
          
            <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      mb: 2,
                      position: "relative",
          
                    }}
                  >
                    {/* This empty box takes space on the left so the title can truly center */}
                    <Box sx={{ width: 150}} />
          
                    {/* Centered Title */}
                    <Typography
                      variant="h5"
                      className="self-title"
                      sx={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        whiteSpace: "nowrap",
          
          
                      }}
                    >
                       Resignation Dashboard
                    </Typography>
          
                    {/* search bar */}
                    {/* <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,               // space between year picker & search
                        mb: 2,
                      }}
                    >
                      <TextField
                        placeholder="Search by ID, Name"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e.target.value);
                          setOffset(1); // reset pagination on search
                        }}
                        size="small"
                        sx={{
                          width: 250,
                          '& .MuiInputBase-root': {
                            height: 40,
                          },
                        }}
                      />
          
                     
                     
                    </Box> */}

 {/* Year filter on right */}
                     <Box sx={{
                        color: '#fff', backgroundColor: '#1e8841ff', width: 140, '& .MuiInputBase-root': {
                          height: 40,
                          minHeight: '40px',
                          gap: 2,               // space between year picker & search
                     
          
                        },
                        '& .MuiInputBase-input': {
                          color: '#fff',  // input text color here
                        },
                        '& .MuiSvgIcon-root': {
                          color: '#fff',  // calendar icon color
                        },
          
                      }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            views={["year"]}
                            value={selectedYear}
                            onChange={handleYearChange}
                            minDate={new Date("2005-01-01")}
                            maxDate={new Date()}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </LocalizationProvider>
                      </Box>
                  </Box>
          

            {HRlist ? (

              <ReusableTable

                data={tableDataModal} 
                count={count}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                // setSearchValue={setSearchValue}
                heading={[
                  "S.No",
                  "Employee Code",
                  "Name",
                  "Role",
                  "Department",
                  "Request Status",
                  "Attrition Type",
                  "Approver Level",
                  "Approval Status",
                  "Applied On",
                  "Action",
                  "View Details"
                ]} 
              />
            ) : (
              <>
                <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>
               
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Employee ID</Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kraCategory"
                      name="kraCategory"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.employeeCode}
                      InputProps={{ readOnly: true }} 
                    />
                  </Grid>

                  
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Employee Name </Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kpiName"
                      name="kpiName"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.firstName}
                      InputProps={{ readOnly: true }} 
                    />
                  </Grid>

                  {resignationDetails.requestStatus !== "Withdrawn" && (
                    <>

                      
                      <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Reason For Leaving</Box>
                        <TextField
                          sx={{ border: "1px solid #B2D4F8" }}
                          id="kpiName"
                          name="kpiName"
                          placeholder=""
                          variant="outlined"
                          fullWidth
                          disabled
                          value={resignationDetails.exitReason}
                          InputProps={{ readOnly: true }} 
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                        <Box className="label">Last Working Date</Box>
                        <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                          <DatePicker
                            sx={{ width: "100%" }}
                            id="dateOfBirth"
                            name="dateOfBirth"
                            value={moment(resignationDetails.LWD).toDate()} 
                            readOnly 
                            disabled 
                            slotProps={{
                              field: { clearable: true },
                            }}
                            format="dd/MM/yyyy"
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                          />
                        </LocalizationProvider>

                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Approval Status<span style={{ color: "red" }}>*</span></Box>
                    <FormControl fullWidth>
                      <Select
                        labelId="self-rating-label"
                        id="selfRating"
                        style={{ border: "2px solid #B2D6F8", color: "grey" }}
                        value={approval}
                        onChange={(e) => setApproval(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>Select</MenuItem>
                        <MenuItem value="Approved">Approve</MenuItem>
                        <MenuItem value="Rejected">Reject</MenuItem>
                      </Select>
                      {errorMessages.approval && <FormHelperText>{errorMessages.approval}</FormHelperText>}

                    </FormControl>
                  </Grid>

                  
                  {approval === "Rejected" && (
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                      <Box className="label">Reason for Rejection<span style={{ color: "red" }}>*</span></Box>

                      <TextField
                        sx={{ border: "1px solid #B2D4F8" }}
                        id="justification"
                        name="justification"
                        placeholder="Enter reason for rejection"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={rejectionReason}
                        onChange={(e) => setRejectionReason(e.target.value.trimStart())} 
                        onBlur={(e) => setRejectionReason(e.target.value.trim())} />
                      {errorMessages.rejectionReason && <FormHelperText>{errorMessages.rejectionReason}</FormHelperText>}

                    </Grid>
                  )}
                  {approval === "Approved" && (
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                      <Box className="label">Reason for Approval<span style={{ color: "red" }}>*</span></Box>

                      <TextField
                        sx={{ border: "1px solid #B2D4F8" }}
                        id="justification"
                        name="justification"
                        placeholder="Enter reason for approval"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={approvalReason}
                        onChange={(e) => setApprovalReason(e.target.value.trimStart())} 
                        onBlur={(e) => setApprovalReason(e.target.value.trim())} />
                      {errorMessages.approvalReason && <FormHelperText>{errorMessages.approvalReason}</FormHelperText>}

                    </Grid>
                  )}

                

                </Grid>
                <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Button className="cancelButton" onClick={() => {
                      setHRlist(true)
                      handleClose()
                    }}>Cancel</Button>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Button className="saveButton" onClick={() => handleOpenSubmitModal()}> Submit </Button>
                  </Grid>
                </Grid>
              </>
            )}


          </div>  </div>

          

            

<Dialog
  open={openModal}
  onClose={handleClose}
  PaperProps={{
    sx: {
      width: "800px",
      maxWidth: "90vw",
      borderRadius: "12px",
      padding: "20px",
      // marginTop: "50px",      // Push it down a bit from top
    },
  }}
  sx={{
    "& .MuiDialog-container": {
      alignItems: "flex-center",   // Align dialog to top instead of center
    },
  }}
  

>
  <DialogTitle sx={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", color: "#4a55cbff" }}>
   Employee Exit Progress Details
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: "#666",
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
 {exitDetailsView && (
  <>
    <Grid container spacing={1} sx={{ mb:3,pl: 1, pr: 1, mt: 1, justifyContent: "space-around" }}>
      <Grid item xs={12} sm={4} >
        <strong >Employee Name:</strong> {exitDetailsView.firstName}
      </Grid>
      <Grid item xs={12} sm={4}>
        <strong>Request Status:</strong> {exitDetailsView.requestStatus}
      </Grid>
     
        <Grid item xs={12} sm={4}>
        <strong>Attrition Type:</strong> {exitDetailsView.attritionType}
      </Grid>
      
      
    </Grid>
     <TableContainer component={Paper}>
        <Table size="medium">
         <TableHead>
  <TableRow>
    <TableCell sx={{ width: "15%", minWidth: "120px" }}>
      <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
        Approval Level
      </Typography>
    </TableCell>
     <TableCell sx={{ width: "15%", minWidth: "120px" }}>
      <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
        Acted By
      </Typography>
    </TableCell>
    <TableCell sx={{ width: "15%", minWidth: "120px" }}>
      <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
        Status
      </Typography>
    </TableCell>
     <TableCell sx={{ width: "15%", minWidth: "120px" }}>
      <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
        Acted On
      </Typography>
    </TableCell>
    <TableCell sx={{ width: "15%", minWidth: "120px" }}>
      <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
        Reason/Remarks
      </Typography>
    </TableCell>
   
   
  </TableRow>
</TableHead>

          <TableBody>

  {[
    "Manager (level 1)",
    "Manager (level 2)",
    "HR",
    "IT",
    "Admin",
    "Finance",
    "HR Final Approval"
  ].map((levelName) => {
    const detail = approvalDetails?.find(
      (item) => item.approvalLevel === levelName
    );

       
     const getApprovalStatus = (approvalDetails, levelName) => {
    
      
if (!approvalDetails) return  <span style={{ color: "gray",fontWeight: "bold" }}>Not Applicable</span>;
let status;
  switch (levelName) {
    case "Manager (level 1)":
      status = approvalDetails?.managerStatus || "Pending";
      break;
    case "Manager (level 2)":
      status =  approvalDetails?.l2ManagerStatus || "Pending";
      break;
    case "HR":
      status =  approvalDetails?.HRStatus || "Pending";
      break;
    case "IT":
      status = approvalDetails?.ITStatus || "Pending";
      break;
    case "Admin":
      status =  approvalDetails?.adminStatus || "Pending";
      break;
    case "Finance":
      status = approvalDetails?.financeStatus || "Pending";
      break;
    case "HR Final Approval":
      status = approvalDetails?.hrFinalApprovalStatus || "Pending";
      break;
    default:
      status = approvalDetails?.approvalStatus || "Not Applicable";
  }
   let color;
  switch (status) {
    case "Approved":
      color = "#327841ff";
      break;
      case "Completed":
      color = "#327841ff";
      break;
    case "Pending":
      color = "#727163ff";
      break;
    case "Rejected":
      color = "#d02222ff";
      break;
    case "Not Applicable":
      color = "#859ea3ff";
      break;
    default:
      color = "black";
  }

return <span style={{ color,fontWeight: "bold" }}>{status}</span>;
};

    return (
      <TableRow key={levelName}>
        <TableCell>{levelName}</TableCell>
        <TableCell>{detail?.approverName || "-"}</TableCell>
      <TableCell>
             {/* <Typography
        sx={{
          
          color:
            detail?.approvalStatus === "Approved" || detail?.approvalStatus === "Completed"
              ? "green"
              : detail?.approvalStatus === "Rejected"
              ? "red"
              : "#797c61ff", // Pending
        }}
      >
        {detail?.approvalStatus
          ? detail.approvalStatus
          : exitDetailsView.attritionType == "Voluntary" || (exitDetailsView?.requestStatus == 'Withdrawn' && levelName == 'Manager (level 1)')
          ? "Pending"
           :  exitDetailsView.attritionType == "Involuntary" && (exitDetailsView?.requestStatus == 'Termination Initiated' && levelName != 'Manager (level 1)' && levelName != 'HR' )
          ? "Pending"
          : "Not Applicable"}
      </Typography> */}
         {getApprovalStatus(approvalDetails[0], levelName)}
      
           </TableCell>
        <TableCell>
          {detail?.date
            ? moment(detail.date).format("DD-MM-YYYY")
            : "-"}
        </TableCell>
        <TableCell>{detail?.remarks || "-"}</TableCell>
      </TableRow>
    );
  })}
</TableBody>

        </Table>
      </TableContainer>
    </>
  )}
</Dialog> 


      </Box>
    </div>
  );
};

export default ExitManagementManager;

